// Landing page shown at root URL (not tenant-scoped).

export function LandingPage() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="space-y-2 text-center">
        <h1 className="text-2xl font-bold text-foreground">Risk Platform</h1>
        <p className="text-muted-foreground">Navigate to your tenant URL to get started.</p>
      </div>
    </div>
  )
}
